import { SETTINGS_PREFIX_KEY } from "../../constants"
import { SettingsKeys, SettingsState, ViewStyles } from "./types"

export const initialSettingsState: SettingsState = {
	viewStyle: (localStorage.getItem(SETTINGS_PREFIX_KEY + SettingsKeys.VIEW_STYLE) as ViewStyles | null) ?? ViewStyles.GRID,
}
